// extracted by mini-css-extract-plugin
module.exports = {"singleCheckbox":"CustomCheckboxes_singleCheckbox__3RR3Y"};